/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { CluIntentSwagger } from 'src/clu/core/services/intents/cluIntentSwaggers';
import { CluIntentStore, OrchestrationInfo } from 'src/clu/core/stores/CluIntentStore';

export const cluIntentSwaggerToCluIntentStore = (intentSwagger: CluIntentSwagger) => {
    const getOrchestrationInfo = (): OrchestrationInfo => {
        const dto = intentSwagger.orchestration;

        if (!dto) {
            return undefined;
        }

        switch (dto.targetProjectKind) {
            case 'Conversation':
                return {
                    orchestrationType: 'Conversation',
                    projectName: dto.conversationOrchestration.projectName,
                    slotName: dto.conversationOrchestration.deploymentName
                };
            case 'Luis':
                return {
                    orchestrationType: 'Luis',
                    appId: dto.luisOrchestration.appId,
                    slotName: dto.luisOrchestration.slotName,
                    versionId: dto.luisOrchestration.appVersion
                };
            case 'QuestionAnswering':
                return {
                    orchestrationType: 'QuestionAnswering',
                    projectName: dto.questionAnsweringOrchestration.projectName
                };
            default:
                return undefined;
        }
    };

    return new CluIntentStore(intentSwagger.category, { orchestrationInfo: getOrchestrationInfo() });
};

export const cluIntentStoreToIntentSwagger = (store: Pick<CluIntentStore, 'name' | 'orchestrationInfo'>): CluIntentSwagger => {
    const getOrchestrationInfo = (): CluIntentSwagger['orchestration'] => {
        const info = store.orchestrationInfo;

        if (!info) {
            return undefined;
        }

        switch (info.orchestrationType) {
            case 'Conversation':
                return {
                    targetProjectKind: 'Conversation',
                    conversationOrchestration: { projectName: info.projectName, deploymentName: info.slotName }
                };
            case 'Luis':
                return {
                    targetProjectKind: 'Luis',
                    luisOrchestration: { appId: info.appId, appVersion: info.versionId, slotName: info.slotName }
                };
            case 'QuestionAnswering':
                return { targetProjectKind: 'QuestionAnswering', questionAnsweringOrchestration: { projectName: info.projectName } };
            default:
                return undefined;
        }
    };

    return { category: store.name, orchestration: getOrchestrationInfo() };
};
